"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
exports.TIME_PART = {
    dayperiod: 'dayperiod',
    hour: 'hour',
    millisecond: 'millisecond',
    minute: 'minute',
    second: 'second'
};
//# sourceMappingURL=TimePart.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/timepicker/models/TimePart.js
// module id = 172
// module chunks = 0